import { InputForm } from "../../../_helpers/components/Forms/InputLabel";
import { Button } from "../../../_helpers/components/Button";
import { cssColor } from "./InterventionsColors";

export const InterventionsDetailModal = (props) => {
    let {
        intervention,
        setVisible,
        handleOpenUpdateModal,
        handleDelete,
        canEnroll,
        userId,
        handleDuplicate,
        loading,
    } = props;

    const priority = {
        URGENT: {
            label: "Urgent",
            color: cssColor.URGENT,
        },
        IMPORTANT: {
            label: "Important",
            color: cssColor.IMPORTANT,
        },
        NORMALE: {
            label: "Normale",
            color: cssColor.NORMALE,
        },
        MEMO: {
            label: "Pour mémo",
            color: cssColor.MEMO,
        },
    }

    const status = {
        OPEN: {
            label: "Ouvert",
            color: cssColor.OPEN,
        },
        ONGOING: {
            label: "En cours",
            color: cssColor.ONGOING,
        },
        PENDING: {
            label: "En attente",
            color: cssColor.PENDING,
        },
        CLOSED: {
            label: "Terminé",
            color: cssColor.CLOSED,
        },
        UNREALIZABLE: {
            label: "Non réalisable",
            color: cssColor.UNREALIZABLE,
        },
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-40" onClick={() => setVisible(false)}>
            <div className="bg-white lg:rounded-2xl shadow-lg w-full lg:max-w-3xl h-full lg:h-auto p-6 h-max-content overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="text-xs text-gray-400 my-2">Id : {intervention.id}</div>
                <div className="text-lg font-semibold text-gray-800 my-2">{intervention.title}</div>
                <div className="italic text-sm text-gray-500 mb-2 line-clamp-1">{intervention.category.family + " > " + intervention.category.label}</div>
                <InputForm
                    name=""
                    value={intervention.description}
                    readOnly={true}
                    type={"textarea"}
                    className="appearance-none block bg-gray-200 border rounded-sm py-2 px-3 mb-3 leading-tight focus:outline-hidden focus:bg-white text-sm text-gray-500 my-2 w-full"
                />

                <div className="grid grid-cols-1 lg:grid-cols-3 my-2">
                    {intervention.team && (
                        <div className="flex grid-cols-2 my-2">
                            <span className="text-gray-600 mr-4">Service&nbsp;:</span>
                            <span
                                className="text-xs px-2 py-1 rounded-full border"
                                style={{
                                    backgroundColor: intervention.team.bg_color,
                                    opacity: "70%",
                                }}>{intervention.team.name}</span>
                        </div>
                    )}

                    <div className="flex grid-cols-2 my-2">
                        <span className="text-gray-600 mr-4">Priorité&nbsp;:</span>
                        <span
                            className={`text-xs px-2 py-1 rounded-full border ${priority[intervention.priority].color}`}
                        >
                            {priority[intervention.priority].label}
                        </span>
                    </div>

                    <div className="flex grid-cols-2 my-2">
                        <span className="text-gray-600 mr-4">Statut&nbsp;:</span>
                        <span
                            className={`text-xs px-2 py-1 rounded-full border ${status[intervention.status].color}`}
                        >
                            {status[intervention.status].label}
                        </span>
                    </div>
                </div>

                <InputForm
                    name=""
                    value={intervention.remarks}
                    readOnly={true}
                    type={"textarea"}
                    className="appearance-none block bg-gray-200 border rounded-sm py-2 px-3 mb-3 leading-tight focus:outline-hidden focus:bg-white text-sm text-gray-500 my-2 w-full"
                />

                {intervention.start_time && (
                    <div className="my-2 text-gray-600 text-sm">
                        <span>Intervention {["CLOSED", "UNREALIZABLE"].includes(intervention.status) ? "terminée" : "prévue"} le {new Date(intervention.start_time).toLocaleDateString()} à {new Date(intervention.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                        {intervention.performer && (
                            <span> par {intervention.performer.last_name} {intervention.performer.first_name}</span>
                        )}
                    </div>
                )}
                {!intervention.start_time && intervention.performer && (
                    <span className="text-gray-600 font-bold">Attribuée à {intervention.performer.last_name} {intervention.performer.first_name}</span>
                )}


                <div className=" my-2 text-gray-600 text-xs">
                    <span>Créée le {new Date(intervention.created_at).toLocaleDateString()} à {new Date(intervention.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                    <span>
                        {intervention.requester && (
                            <> par {intervention.requester.last_name} {intervention.requester.first_name}</>
                        )}
                    </span>
                </div>
                {intervention.due_date && (
                    <span>Échéance : {new Date(intervention.due_date).toLocaleDateString()}</span>
                )}
                <div className="flex flex-wrap justify-end gap-2 pt-4">
                    {((intervention.status === "OPEN" && canEnroll && (intervention.performer == null || intervention.performer_id == userId))
                        ||
                        (["ONGOING", "PENDING"].includes(intervention.status) && intervention.performer_id == userId))
                        && (
                            <>
                                {handleOpenUpdateModal &&
                                    (<Button
                                        action={() => { handleOpenUpdateModal(intervention, "CLOSED") }}
                                        title="Clôturer l'intervention"
                                        name="🎯 Clôturer"
                                    />)
                                }
                                {handleOpenUpdateModal &&
                                    (<Button
                                        action={() => handleOpenUpdateModal(intervention)}
                                        title="Mettre à jour l'intervention"
                                        name="📅 Modifier"
                                    />)
                                }
                            </>
                        )}
                    {handleDuplicate &&
                        <Button
                            action={() => handleDuplicate(intervention)}
                            title="Dupliquer l'intervention"
                            name=<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                            </svg>

                        />
                    }
                    < Button name="Fermer" type="empty" action={() => setVisible(false)} />

                    {intervention.status === "OPEN" && intervention.requester_id === userId && (
                        <Button
                            action={() => handleDelete(intervention.id)}
                            className="text-gray-400 hover:text-red-500 cursor-pointer"
                            title="Supprimer la demande d'intervention"
                            type="red"
                            loading={loading}
                            name={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                </svg>

                            }
                        />
                    )}

                </div>
            </div>
        </div>
    )
}